import Vue from 'vue';
import Router from 'vue-router';




import planing_home from '@/components/planing/home/home';
import planning_bidang_urusan from './components/planing/data_master/urusan/bidang.vue';
import planing_satker_bidang from './components/planing/data_master/urusan/satker_bidang.vue';
import planing_unit_kerja from './components/planing/data_master/urusan/unit_kerja.vue';
import planing_urusan from './components/planing/data_master/urusan/urusan.vue';
import planning_provinsi from './components/planing/data_master/data_wilayah/provinsi.vue';
import planning_kabupaten from './components/planing/data_master/data_wilayah/kabupaten.vue';
import planning_kecamatan from './components/planing/data_master/data_wilayah/kecamatan.vue';
import planning_data_wilayah_des_kel from './components/planing/data_master/data_wilayah/des_kel.vue';

import planing_fungsi from './components/planing/data_master/fungsi/fungsi.vue';
import planning_indikator_tujuan_pembangunan from './components/planing/RPJMD/indikator_tujuan_pembangunan.vue';
import planing_bidang_musrembang from './components/planing/data_master/bidang_musrembang/bidang_musrembang.vue';

// ============================== RPJMD ====================================
  import planing_rpjmd            from './components/planing/RPJMD/rpjmd'
  import planing_permasalahan_pembangunan from './components/planing/RPJMD/permasalahan_pembangunan'
  import planing_isu_strategis            from './components/planing/RPJMD/isu_strategis'
  import planing_visi                     from './components/planing/RPJMD/visi'
  import planing_misi                     from './components/planing/RPJMD/misi'
  import planing_tujuan                   from './components/planing/RPJMD/tujuan'
  import planing_sasaran                  from './components/planing/RPJMD/sasaran'
  import planing_strategi                 from './components/planing/RPJMD/strategi'
  import planing_arah_kebijakan           from './components/planing/RPJMD/arah_kebijakan'
  import planing_arah_kebijakan_tahunan   from './components/planing/RPJMD/arah_kebijakan_tahunan'
  import planing_kebijakan_umum           from './components/planing/RPJMD/kebijakan_umum'
  import planing_program_unggulan         from './components/planing/RPJMD/program_unggulan'
  import planing_program_pembangunan      from './components/planing/RPJMD/program_pembangunan'
  import planing_indikator_kinerja        from './components/planing/RPJMD/indikator_kinerja'
  import planing_proyeksi_anggaran        from './components/planing/RPJMD/proyeksi_anggaran'
// ============================== RPJMD ====================================

// ============================== RENSTRA ====================================
  import planing_renstra_renstra from './components/planing/RENSTRA/renstra_renstra.vue'
  import planing_renstra_visi from './components/planing/RENSTRA/renstra_visi.vue'
  import planing_renstra_misi from './components/planing/RENSTRA/renstra_misi.vue'
  import planing_renstra_tujuan from './components/planing/RENSTRA/renstra_tujuan.vue'
  import planing_renstra_sasaran from './components/planing/RENSTRA/renstra_sasaran.vue'
  import planing_renstra_strategi from './components/planing/RENSTRA/renstra_strategi.vue'
  import planing_renstra_arah_kebijakan from './components/planing/RENSTRA/renstra_arah_kebijakan.vue'
  import planing_renstra_kebijakan_umum from './components/planing/RENSTRA/renstra_kebijakan_umum.vue'
  import planing_renstra_program from './components/planing/RENSTRA/renstra_program.vue'
  import planing_renstra_kegiatan from './components/planing/RENSTRA/renstra_kegiatan.vue'
  import planing_laporan_renstra from './components/planing/RENSTRA/laporan/laporan_renstra.vue'
  import planing_laporan_sasaran_program from './components/planing/RENSTRA/laporan/laporan_sasaran_program.vue'
  import planing_laporan_keselarasan_kinerja from './components/planing/RENSTRA/laporan/keselarasan_kinerja.vue'
// ============================== RENSTRA ====================================

// ============================== MUSRENBANG ====================================
  import planing_ver_musrenbang_OPD from './components/planing/MUSRENBANG/Forum_OPD/ver_musrenbang_OPD.vue'
  import planing_lap_musrenbang_OPD from './components/planing/MUSRENBANG/Forum_OPD/lap_musrenbang_OPD.vue'
  import planing_musrenbang_opd from './components/planing/MUSRENBANG/Forum_OPD/musrenbang_opd.vue'
  import planing_ver_musrenbang_kecamatan from './components/planing/MUSRENBANG/kecamatan/ver_musrenbang_kecamatan.vue'
  import planing_musrenbang_kecamatan from './components/planing/MUSRENBANG/kecamatan/musrenbang_kecamatan.vue'
  import planing_lap_musrenbang_kecamatan from './components/planing/MUSRENBANG/kecamatan/lap_musrenbang_kecamatan.vue'
  import planing_musrenbang_pokir from './components/planing/MUSRENBANG/pokir/musrenbang_pokir.vue'
  import planing_ver_musrenbang_pokir from './components/planing/MUSRENBANG/pokir/ver_musrenbang_pokir.vue'
  import planing_lap_musrenbang_pokir from './components/planing/MUSRENBANG/pokir/lap_musrenbang_pokir.vue'
// ============================== MUSRENBANG ====================================



// ============================== RKPD ====================================
  import planing_rkpd_awal from './components/planing/RKPD/rkpd_awal.vue'
  import planing_rkpd_final from './components/planing/RKPD/rkpd_final.vue'
  import planing_rkpd_program from './components/planing/RKPD/rkpd_program.vue'
  import planing_rkpd_kegiatan from './components/planing/RKPD/rkpd_kegiatan.vue'
  import planing_rkpd_prioritas_nasional from './components/planing/RKPD/rkpd_prioritas_nasional.vue'
  import planing_rkpd_prioritas_provinsi from './components/planing/RKPD/rkpd_prioritas_provinsi.vue'
  import planing_rkpd_prioritas_daerah from './components/planing/RKPD/rkpd_prioritas_daerah.vue'
// ============================== RKPD ====================================

// ============================== RENJA ====================================
  import planing_renja_setup from './components/planing/RENJA/renja_setup.vue'
  import planing_dok_rencana_skpd from './components/planing/RENJA/dok_rencana_skpd.vue'
  import planing_renja_pendapatan from './components/planing/RENJA/renja_anggaran/renja_pendapatan.vue'
  import planing_renja_belanja_tidak_langsung from './components/planing/RENJA/renja_anggaran/renja_belanja_tidak_langsung.vue'
  import planing_renja_penerimaan from './components/planing/RENJA/renja_anggaran/renja_penerimaan.vue'
  import planing_renja_pengeluaran from './components/planing/RENJA/renja_anggaran/renja_pengeluaran.vue'
  import planing_renja_program from './components/planing/RENJA/renja_belanja_langsung/renja_program.vue'
  import planing_renja_kegiatan from './components/planing/RENJA/renja_belanja_langsung/renja_kegiatan.vue'
  import planing_renja_evaluasi_program from './components/planing/RENJA/evaluasi_renja/renja_evaluasi_program.vue'
  import planing_renja_evaluasi_kegiatan from './components/planing/RENJA/evaluasi_renja/renja_evaluasi_kegiatan.vue'
  import planing_renja_tindak_lanjut from './components/planing/RENJA/evaluasi_renja/renja_tindak_lanjut.vue'
  import planing_renja_rekapitulasi from './components/planing/RENJA/laporan/renja_rekapitulasi.vue'
  import planing_renja_permendagri from './components/planing/RENJA/laporan/renja_permendagri.vue'
// ============================== RENJA ====================================

// ============================== RKA ====================================
import planing_ppas               from './components/planing/RKA/setup rka/ppas'
import planing_hapus_rka          from './components/planing/RKA/setup rka/hapus_rka'
import planing_sum_ang            from './components/planing/RKA/setup rka/sum_ang'
import planing_tim                from './components/planing/RKA/setup rka/tim'
import planing_batas              from './components/planing/RKA/setup rka/batas'


import planing_akun               from './components/planing/RKA/kode rekening/akun'
import planing_kelompok           from './components/planing/RKA/kode rekening/kelompok'
import planing_jenis           from './components/planing/RKA/kode rekening/jenis'
import planing_objek           from './components/planing/RKA/kode rekening/objek'
import planing_rincian           from './components/planing/RKA/kode rekening/rincian'
import planing_barang           from './components/planing/RKA/kode rekening/barang'
// ============================== END RKA ====================================

// ============================== PROGRAM KEGIATAN ====================================
import planing_program from './components/planing/data_master/program_kegiatan/program';
import planing_kegiatan from './components/planing/data_master/program_kegiatan/kegiatan';
// ============================== END PROGRAM KEGIATAN ====================================



import master_jabatan from './components/data_master/jabatan_tupoksi/jabatan.vue';
import master_tupoksi from './components/data_master/jabatan_tupoksi/tupoksi.vue';
import master_biodata from './components/data_master/jabatan_tupoksi/biodata.vue';





// import './assets/css/kiken/kiken.css'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

Vue.filter('dateCut', function (value) {
  return value.substring(0, value.indexOf('T'))
})

Vue.use(Router)



function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/dashboard');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/monev_login');
  }
}

var routes = [
    {
        path: '/planing',
        name: '/planing',
        component: planing_home,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/planning_bidang_urusan',
      name: '/planning_bidang_urusan',
      component: planning_bidang_urusan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_unit_kerja',
      name: '/planing_unit_kerja',
      component: planing_unit_kerja,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_satker_bidang',
      name: '/planing_satker_bidang',
      component: planing_satker_bidang,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_urusan',
      name: '/planing_urusan',
      component: planing_urusan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planning_data_wilayah_provinsi',
      name: '/planning_data_wilayah_provinsi',
      component: planning_provinsi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planning_data_wilayah_kabupaten',
      name: '/planning_data_wilayah_kabupaten',
      component: planning_kabupaten,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planning_data_wilayah_kecamatan',
      name: '/planning_data_wilayah_kecamatan',
      component: planning_kecamatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planning_data_wilayah_des_kel',
      name: '/planning_data_wilayah_des_kel',
      component: planning_data_wilayah_des_kel,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/planning_indikator_tujuan_pembangunan',
      name: '/planning_indikator_tujuan_pembangunan',
      component: planning_indikator_tujuan_pembangunan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_fungsi',
      name: '/planing_fungsi',
      component: planing_fungsi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_bidang_musrembang',
      name: '/planing_bidang_musrembang',
      component: planing_bidang_musrembang,
      beforeEnter: isLoggedIn,
    },

// ============================== RPJMD ====================================
    {
      path: '/planing_rpjmd',
      name: '/planing_rpjmd',
      component: planing_rpjmd,
      beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_permasalahan_pembangunan',
        name: '/planing_permasalahan_pembangunan',
        component: planing_permasalahan_pembangunan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_isu_strategis',
        name: '/planing_isu_strategis',
        component: planing_isu_strategis,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_visi',
        name: '/planing_visi',
        component: planing_visi,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_misi',
        name: '/planing_misi',
        component: planing_misi,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_tujuan',
        name: '/planing_tujuan',
        component: planing_tujuan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_sasaran',
        name: '/planing_sasaran',
        component: planing_sasaran,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_strategi',
        name: '/planing_strategi',
        component: planing_strategi,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_arah_kebijakan',
        name: '/planing_arah_kebijakan',
        component: planing_arah_kebijakan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_arah_kebijakan_tahunan',
        name: '/planing_arah_kebijakan_tahunan',
        component: planing_arah_kebijakan_tahunan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_kebijakan_umum',
        name: '/planing_kebijakan_umum',
        component: planing_kebijakan_umum,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_program_unggulan',
        name: '/planing_program_unggulan',
        component: planing_program_unggulan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_program_pembangunan',
        name: '/planing_program_pembangunan',
        component: planing_program_pembangunan,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_indikator_kinerja',
        name: '/planing_indikator_kinerja',
        component: planing_indikator_kinerja,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/planing_proyeksi_anggaran',
        name: '/planing_proyeksi_anggaran',
        component: planing_proyeksi_anggaran,
        beforeEnter: isLoggedIn,
    },
// ============================== END RPJMD ====================================

// ============================== RENSTRA ====================================
    {
      path: '/planing_renstra_renstra',
      name: '/planing_renstra_renstra',
      component: planing_renstra_renstra,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_visi',
      name: '/planing_renstra_visi',
      component: planing_renstra_visi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_misi',
      name: '/planing_renstra_misi',
      component: planing_renstra_misi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_tujuan',
      name: '/planing_renstra_tujuan',
      component: planing_renstra_tujuan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_sasaran',
      name: '/planing_renstra_sasaran',
      component: planing_renstra_sasaran,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_strategi',
      name: '/planing_renstra_strategi',
      component: planing_renstra_strategi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_arah_kebijakan',
      name: '/planing_renstra_arah_kebijakan',
      component: planing_renstra_arah_kebijakan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_kebijakan_umum',
      name: '/planing_renstra_kebijakan_umum',
      component: planing_renstra_kebijakan_umum,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_program',
      name: '/planing_renstra_program',
      component: planing_renstra_program,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renstra_kegiatan',
      name: '/planing_renstra_kegiatan',
      component: planing_renstra_kegiatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_laporan_renstra',
      name: '/planing_laporan_renstra',
      component: planing_laporan_renstra,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_laporan_sasaran_program',
      name: '/planing_laporan_sasaran_program',
      component: planing_laporan_sasaran_program,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_laporan_keselarasan_kinerja',
      name: '/planing_laporan_keselarasan_kinerja',
      component: planing_laporan_keselarasan_kinerja,
      beforeEnter: isLoggedIn,
    },

    
// ============================== RENSTRA ====================================

// ============================== RKPD ====================================
    {
      path: '/planing_rkpd_awal',
      name: '/planing_rkpd_awal',
      component: planing_rkpd_awal,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_rkpd_final',
      name: '/planing_rkpd_final',
      component: planing_rkpd_final,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_rkpd_program',
      name: '/planing_rkpd_program',
      component: planing_rkpd_program,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_rkpd_kegiatan',
      name: '/planing_rkpd_kegiatan',
      component: planing_rkpd_kegiatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_rkpd_prioritas_nasional',
      name: '/planing_rkpd_prioritas_nasional',
      component: planing_rkpd_prioritas_nasional,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_rkpd_prioritas_provinsi',
      name: '/planing_rkpd_prioritas_provinsi',
      component: planing_rkpd_prioritas_provinsi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_rkpd_prioritas_daerah',
      name: '/planing_rkpd_prioritas_daerah',
      component: planing_rkpd_prioritas_daerah,
      beforeEnter: isLoggedIn,
    },
// ============================== RKPD ====================================

// ============================== MUSRENBANG ====================================
    {
      path: '/planing_ver_musrenbang_OPD',
      name: '/planing_ver_musrenbang_OPD',
      component: planing_ver_musrenbang_OPD,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_lap_musrenbang_OPD',
      name: '/planing_lap_musrenbang_OPD',
      component: planing_lap_musrenbang_OPD,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_musrenbang_opd',
      name: '/planing_musrenbang_opd',
      component: planing_musrenbang_opd,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_ver_musrenbang_kecamatan',
      name: '/planing_ver_musrenbang_kecamatan',
      component: planing_ver_musrenbang_kecamatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_musrenbang_kecamatan',
      name: '/planing_musrenbang_kecamatan',
      component: planing_musrenbang_kecamatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_lap_musrenbang_kecamatan',
      name: '/planing_lap_musrenbang_kecamatan',
      component: planing_lap_musrenbang_kecamatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_musrenbang_pokir',
      name: '/planing_musrenbang_pokir',
      component: planing_musrenbang_pokir,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_ver_musrenbang_pokir',
      name: '/planing_ver_musrenbang_pokir',
      component: planing_ver_musrenbang_pokir,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_lap_musrenbang_pokir',
      name: '/planing_lap_musrenbang_pokir',
      component: planing_lap_musrenbang_pokir,
      beforeEnter: isLoggedIn,
    },
// ============================== MUSRENBANG ====================================

// ============================== RENJA ====================================
    {
      path: '/planing_renja_setup',
      name: '/planing_renja_setup',
      component: planing_renja_setup,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_dok_rencana_skpd',
      name: '/planing_dok_rencana_skpd',
      component: planing_dok_rencana_skpd,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_pendapatan',
      name: '/planing_renja_pendapatan',
      component: planing_renja_pendapatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_belanja_tidak_langsung',
      name: '/planing_renja_belanja_tidak_langsung',
      component: planing_renja_belanja_tidak_langsung,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_penerimaan',
      name: '/planing_renja_penerimaan',
      component: planing_renja_penerimaan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_pengeluaran',
      name: '/planing_renja_pengeluaran',
      component: planing_renja_pengeluaran,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_program',
      name: '/planing_renja_program',
      component: planing_renja_program,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_kegiatan',
      name: '/planing_renja_kegiatan',
      component: planing_renja_kegiatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_evaluasi_program',
      name: '/planing_renja_evaluasi_program',
      component: planing_renja_evaluasi_program,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_evaluasi_kegiatan',
      name: '/planing_renja_evaluasi_kegiatan',
      component: planing_renja_evaluasi_kegiatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_tindak_lanjut',
      name: '/planing_renja_tindak_lanjut',
      component: planing_renja_tindak_lanjut,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_rekapitulasi',
      name: '/planing_renja_rekapitulasi',
      component: planing_renja_rekapitulasi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_renja_permendagri',
      name: '/planing_renja_permendagri',
      component: planing_renja_permendagri,
      beforeEnter: isLoggedIn,
    },

// ============================== RENJA ====================================

// ============================== RKA ====================================
    {
      path: '/planing_hapus_rka',
      name: '/planing_hapus_rka',
      component: planing_hapus_rka,
      beforeEnter: isLoggedIn,
    },
    {
    path: '/planing_ppas',
      name: '/planing_ppas',
      component: planing_ppas,
      beforeEnter: isLoggedIn,
    },
    {

    path: '/planing_sumber_anggaran',
    name: '/planing_sum_ang',
    component: planing_sum_ang,
    beforeEnter: isLoggedIn,

    },
    {

    path: '/planing_tim_anggaran',
    name: '/planing_tim',
    component: planing_tim,
    beforeEnter: isLoggedIn,

    },
    {
    path: '/planing_batas_rka',
    name: '/planing_batas',
    component: planing_batas,
    beforeEnter: isLoggedIn,
    },
    {
    path: '/planing_kode_akun',
    name: '/planing_akun',
    component: planing_akun,
    beforeEnter: isLoggedIn,
    },
    {
    path: '/planing_kode_kelompok',
    name: '/planing_kelompok',
    component: planing_kelompok,
    beforeEnter: isLoggedIn,
    },
    {
    path: '/planing_kode_jenis',
    name: '/planing_jenis',
    component: planing_jenis,
    beforeEnter: isLoggedIn,
    },
    {
    path: '/planing_kode_objek',
    name: '/planing_objek',
    component: planing_objek,
    beforeEnter: isLoggedIn,
    },
    {
    path: '/planing_rincian',
    name: '/planing_rincian',
    component: planing_rincian,
    beforeEnter: isLoggedIn,
    },
    {
    path: '/planing_kode_barang',
    name: '/planing_barang',
    component: planing_barang,
    beforeEnter: isLoggedIn,
    },
// ============================== END RKA ====================================

// ============================== PROGRAM KEGIATAN ====================================
    {
      path: '/planing_program',
      name: '/planing_program',
      component: planing_program,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/planing_kegiatan',
      name: '/planing_kegiatan',
      component: planing_kegiatan,
      beforeEnter: isLoggedIn,
    },


// ============================== END PROGRAM KEGIATAN ====================================


    {
      path: '/master_jabatan',
      name: '/master_jabatan',
      component: master_jabatan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/master_tupoksi',
      name: '/master_tupoksi',
      component: master_tupoksi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/master_biodata',
      name: '/master_biodata',
      component: master_biodata,
      beforeEnter: isLoggedIn,
    },


  ]



export default routes
